import React, { useState } from 'react';
import _sortBy from 'lodash/sortBy';

import { Menu, MenuItem, ListSubheader } from '@mui/material';

import DrawerSettingsIconButton from './drawer-settings-icon-button';
import NavigationLink from './navigation-link';

const DrawerSettingsMenu = ({
  areaHasSelectedSetting,
  tooltipTitle,
  settings,
  isDrawerOpen
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleClickSettings = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <DrawerSettingsIconButton
        isDrawerOpen={isDrawerOpen}
        areaHasSelectedSetting={areaHasSelectedSetting}
        handleOnClick={handleClickSettings}
        tooltipTitle={tooltipTitle}
      />

      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleClose}
        variant="menu"
        sx={{ lineHeight: 2 }}
        MenuListProps={{
          'aria-labelledby': 'settings-button',
          role: 'listbox',
          component: 'nav',
          dense: true
        }}
      >
        {_sortBy(settings, 'order').map(({ title: sectionTitle, id, paths }) => {
          return [
            sectionTitle ? (
              <ListSubheader key={id} component="span" sx={{ lineHeight: 2 }}>
                {sectionTitle}
              </ListSubheader>
            ) : null,
            _sortBy(paths, ['order', 'title']).map(({ title, path }) => (
              <MenuItem
                sx={{
                  mx: sectionTitle && 1,
                  color: 'navigationDrawer.text.base',
                  '&:hover': {
                    backgroundColor: 'navigationDrawer.background.hover',
                    color: 'navigationDrawer.text.hover'
                  },
                  '&.listItemSelected': {
                    backgroundColor: 'navigationDrawer.background.selected',
                    color: 'navigationDrawer.text.selected'
                  }
                }}
                key={title}
                activeClassName="listItemSelected"
                component={NavigationLink}
                to={path}
                onClick={handleMenuItemClick}
              >
                {title}
              </MenuItem>
            ))
          ];
        })}
      </Menu>
    </>
  );
};

export default DrawerSettingsMenu;
